// Setup some vars to hold the elements
var donate = document.getElementById('contribution');
var dsign = document.getElementById('dsign');

// Make sure we have the elements needed
if ( donate && dsign) {
	donate.addEventListener('keyup', inputSizer);		
}

function inputSizer(e) {
	// Determine length of current value and add 1 (since we are pushing another)
	var clength = donate.value.length;
	var commas = donate.value.split(',').length;
	clength = clength - (commas - 1);
	if ( clength >= 3 ) {
		donate.size = clength;
	} else {
		donate.size = "3";
	}
}


	
